import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import { TimelineMax, TweenMax, Linear } from 'gsap';

import Button from '../components/Button'
import CustomHelmet from '../components/CustomHelmet'

import Testimonials from '../components/_Redesign/Testimonials'
import AdmissionsSignup from '../components/_Redesign/AdmissionsSignup'
import Signup from '../components/_Redesign/Signup'
import Issues from '../components/_Redesign/Issues'
import Fellows from '../components/_Redesign/Fellows'
import TheSchedule from '../components/TheSchedule'

var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')

    // import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
	// require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
}

class Impact extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            controller: null
        }
    }
    componentDidMount() {
        this.controller = new ScrollMagic.Controller()

        this.setState({
            controller: this.controller
        })

        const timeline = this.refs.timeline

        if( timeline ) {
            const points = Array.from(timeline.getElementsByClassName('timeline-point'))

            points.map( (point) => {
                const progressBar = point.getElementsByClassName('timeline-progress-bar')[0]
                if( progressBar ) {
                    // const toGrow = (point.clientHeight + 80) * 3
                    // const TL = new TimelineMax()
                    // TL.to(progressBar, 0.45, { height: toGrow})

                    const progressScroll = new ScrollMagic.Scene({
                        triggerElement: progressBar,
                        triggerHook: 0.5
                    })
                    .setClassToggle(point, 'extended')
                    .addTo(this.controller)
                    // .addIndicators()
                    // console.log('TO GROW === ', point.parentNode, toGrow);

                }
            })
        }
    }
	componentWillUnmount() {
       // this.state.controller.destroy(true)
       // this.controller.destroy(true)
	}
    scrollTo(id) {
        this.refs[id].scrollIntoView({ behavior: 'smooth' })
    }

  render() {
    const pageData = this.props.pathContext.data

    return (
        <div className="page-redesign page-our-impact">
            <div className="hero">
                <div className="hero-content">
                    <p className="pre-header font-bold">Our Impact</p>
                    <h1 className="h1 large">From Our Founder</h1>
                    <p>When I finished high school I was determined to find an experience that would shape my values, identity and sense of purpose before setting foot on a college campus. I’d been a good student, checked the boxes, and gotten into Stanford.  But I knew in my gut, something was missing: I’d let school interfere with my real education.<br/>
                    <br/>Ever since, I’ve been obsessed with the historic opportunity to create a new -- and better -- cultural template for the transition into adulthood.<br/>
                    <br/>There’s a developmental magic in the moment when a young person has the maturity to leave home but hasn’t yet fixed their values or identity. But in today’s world, high-achieving students hustle toward an abstract finish line; they're discouraged from stepping off the treadmill -- let alone adjusting the incline or speed.<br/>
                    <br/>Since 2010, Global Citizen Year has helped over 1,500 exceptional young people find their purpose, their people and their power to change the world. We’re changing the <em>who</em> and <em>how</em> of our next generation leaders in order to create a more inclusive, equitable, and sustainable future.<br/>
                    <br/>Today we have a world-class team, a stellar track-record, and a dynamic (and growing!) community of alumni, partners and donors worldwide. Together we’re building the world’s launch pad for changemakers -- equipping leaders who reflect society’s diversity and are equipped to change the world, for good.<br/>
                    <br/>Will you join us?</p>
                    <div className="sig-wrapper">
                        <img src="/images/impact-headshot.jpg" alt="gcy impact" style={{ width: '250px', marginTop: '20px' }} /><br/>
                        <img className="sig" src="https://images.ctfassets.net/j91b9gwu8s3q/XTPyNapXHiFugwlhOLaGR/92ab3bb63a02f5e1d5648798d1b31750/Untitled_design__11___1_.png" style={{ maxWidth: '150px' }} />
                    </div>
                </div>
                <div>
                    <img src="/images/yellow-strokes-tall.png" alt="" style={{ position: 'absolute', right: '0' }} id="impact-strokes" />
                </div>
            </div>
            <section className="bg-dark-grey">
                <div className="block-page-navigation bg-grey capper" style={{ transform: 'translateY(-50%)' }}>
                    <ul className="flex">
                        <li><a className="hoverlink" onClick={ () => this.scrollTo('by-the-numbers') }>By The Numbers</a></li>
                        <li><a className="hoverlink" onClick={ () => this.scrollTo('a-transformative-experience') }>A Transformative Experience</a></li>
                        <li><a className="hoverlink" onClick={ () => this.scrollTo('a-lifetime-of-impact') }>A Lifetime of Impact</a></li>
                    </ul>
                </div>
                <div className="block two-col-block by-numbers standard-spacing capper" ref="by-the-numbers">
                    <div>
                        <h2 className="h1">BY THE NUMBERS</h2>
                    </div>
                    <div className="grid-2">
                       <div>
                            <h3 className="boldItal">2010</h3>
                            <p>Founded</p>
                        </div>
                         <div>
                            <h3 className="boldItal">1500</h3>
                            <p>New Leaders</p>
                        </div>
                         <div>
                            <h3 className="boldItal">68</h3>
                            <p>Countries</p>
                        </div>
                         <div>
                            <h3 className="boldItal">$25M</h3>
                            <p>Scholarships</p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="block standard-spacing block-stats-cards capper">
                    <div className="stats-card">
                        <img src="/images/impact/card1.jpg" alt="gcy card image" />
                        <div className="card-content">
                            <h3>51%</h3>
                            <p>of Global Citizen Year students are from low income backgrounds</p>
                            <p className="caps">compared to</p>
                            <h3>16%</h3>
                            <p>of gap year participants nationally</p>
                        </div>
                    </div>

                     <div className="stats-card">
                        <img src="/images/impact/card2.jpg" alt="gcy card image" />
                        <div className="card-content">
                            <h3>46%</h3>
                            <p>of Global Citizen Year students are students of color</p>
                            <p className="caps">compared to</p>
                            <h3>16%</h3>
                            <p>of gap year participants nationally</p>
                        </div>
                    </div>

                     <div className="stats-card">
                        <img src="/images/impact/card3.jpg" alt="gcy card image" />
                        <div className="card-content">
                            <h3>80%</h3>
                            <p>of all Global Citizen Year students receive <strong>need-based financial aid</strong></p>
                            <p className="caps">and</p>
                            <h3>30%</h3>
                            <p>of all Global Citizen Year students receive <strong>full financial aid</strong></p>
                        </div>
                    </div>
                </div>
            </section>

            { /* <section className="bg-grey">
                <div className="block block-diverse two-col-block standard-spacing capper">
                    <div>
                        <h3 className="alt boldItal m-60">
                            we are shaping diverse young leaders in ways classroom learning
and traditional study abroad cannot
                        </h3>
                        <div className="dot-wrap"><span className="dot orange"></span>BEFORE</div>
                        <div className="dot-wrap"><span className="dot yellow"></span>AFTER</div>
                    </div>
                    <div className="text-center">
                        <div className="bar-outer">
                            <div className="bar-wrap">
                                <span className="bar-fill orange" style={{ width: '23%' }}></span>
                            </div>
                            <div className="bar-wrap">
                                <span className="bar-fill yellow" style={{ width: '85%' }}></span>
                            </div>
                            <h3>23% <span><img src="/images/impact/arrow.svg" /></span> 85%</h3>
                            <p>Emotionally prepared for college</p>
                        </div>
                         <div>
                            <div className="bar-wrap">
                                <span className="bar-fill orange" style={{ width: '35%' }}></span>
                            </div>
                            <div className="bar-wrap">
                                <span className="bar-fill yellow" style={{ width: '95%' }}></span>
                            </div>
                            <h3>35% <span><img src="/images/impact/arrow.svg" /></span> 95%</h3>
                            <p>Confident solving problems personally & intellectually</p>
                        </div>
                    </div>
                </div>
            </section> */ }

            <section>
                <div className="block standard-spacing capper block-transform" ref="a-transformative-experience">
                    <p className="pre-header font-bold orange">A Transformative Experience</p>
                    <h2 className="h1 large boldItal">Learn how<br />Global Citizen<br />Year alumni...</h2>
                    <div className="block block-diverse two-col-block">
                        <div className="text-center">
                            <div className="bar-outer">
                                <div className="bar-wrap">
                                    <span className="bar-fill orange" style={{ width: '23%' }}></span>
                                </div>
                                <div className="bar-wrap">
                                    <span className="bar-fill yellow" style={{ width: '85%' }}></span>
                                </div>
                                <h3>23% <span><img src="/images/impact/arrow.svg" /></span> 85%</h3>
                                <p>Emotionally prepared for college</p>
                            </div>
                             <div>
                                <div className="bar-wrap">
                                    <span className="bar-fill orange" style={{ width: '21%' }}></span>
                                </div>
                                <div className="bar-wrap">
                                    <span className="bar-fill yellow" style={{ width: '76%' }}></span>
                                </div>
                                <h3>21% <span><img src="/images/impact/arrow.svg" /></span> 76%</h3>
                                <p>Have clear goals for college</p>
                            </div>
                                <div style={{ marginTop: '40px' }}>
                                    <div className="dot-wrap"><span className="dot orange"></span>BEFORE</div>
                                    <div className="dot-wrap"><span className="dot yellow"></span>AFTER</div>
                                </div>
                        </div>
                        <div>
                            <h3>Maximize College</h3>
                            <p>Alumni have the insights and agency to make the most of college</p>
                            <div className="flex">
                                <span className="boldItal">91%</span>
                                <p>say their Global Citizen Year has been instrumental in shaping their college experience</p>
                            </div>
                             <div className="flex">
                                <span className="boldItal">90%</span>
                                <p>say their Global Citizen Year increased their self-confidence</p>
                            </div>
                             <div className="flex">
                                <span className="boldItal">78%</span>
                                <p>say their Global Citizen Year helped them develop the agency to make the most of college</p>
                            </div>
                        </div>
                    </div>
                </div>
                <img className="strokes" src="/images/impact/yellow-strokes-alt.png" alt="strokes" />
            </section>

              <section className="standard-spacing no-padding-top no-padding-bottom remove-padding-tablet">
                <div className="block quote-block standard-spacing bg-black text-center">
                    <p className="large color-white">Global Citizen Year changed the way I see my education. It isn't a pipeline. It's a complicated network of roads, highways, and choices all of which could take me down different courses. My Global Citizen Year is my GPS."</p>
                    <img src="/images/impact/jj-head.png" className="headshot" alt="author headshot"/>
                    <p className="credit mini color-white">J.I. Cruz, Senegal '15, American University '19</p>
                </div>
            </section>

            <section>
                <div className="block standard-spacing two-col-block align-middle">
                    <div className="text-center">
                        <h2 className="h1 boldItal giant">91%</h2>
                        <p className="font-bold">of Fellows placed in Brazil, Ecuador or Senegal return proficient in a second language</p>
                    </div>
                    <div>
                     <h3>Apply Cross-cultural Skills</h3>
                     <p>Alumni use curiosity and empathy to work effectively across lines of difference</p>
                        <div className="flex">
                            <span className="boldItal">97%</span>
                            <p>are able to see the world from someone else’s perspective</p>
                        </div>
                         <div className="flex">
                            <span className="boldItal">97%</span>
                            <p>are able to work cooperatively with diverse groups</p>
                        </div>
                         <div className="flex">
                            <span className="boldItal">97%</span>
                            <p>have tolerance for others with different beliefs</p>
                        </div>
                    </div>
                </div>
            </section>

             <section className="standard-spacing no-padding-top no-padding-bottom remove-padding-tablet">
                <div className="block quote-block standard-spacing bg-black text-center">
                    <p className="large color-white">My Global Citizen Year is the defining, pivotal point of my life, and has impacted every choice I've made since. I am a different human being on a cellular level. The way I interact with the world is different. I used to be closed off to everything because of uncertainty and fear. Now I aim higher and dream bigger.””</p>
                    <img src="/images/impact/allie-head.png" className="headshot" alt="author headshot"/>
                    <p className="credit mini color-white">Allie McKinney, Senegal '14, University of North Carolina '18</p>
                </div>
            </section>


             <section>
                <div className="block standard-spacing two-col-block">
                    <div>
                        <img src="/images/impact/citizens.jpg" alt="transformative photo" />
                    </div>
                    <div>
                        <h3>Become Engaged Citizens</h3>
                        <p>Alumni demonstrate the courage to stand up for their beliefs</p>
                        <div className="flex">
                            <span className="boldItal">91%</span>
                            <p>believe it is ‘very important’ or ‘essential’ to challenge inequity in all its forms</p>
                        </div>
                        <div className="flex">
                            <span className="boldItal">97%</span>
                            <p>have challeged others on issues of discrimination during the past year</p>
                        </div>
                        <div className="flex">
                            <span className="boldItal">99%</span>
                            <p>recognize the biases that affect their own thinking</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="standard-spacing no-padding-top no-padding-bottom remove-padding-tablet">
                <div className="block quote-block standard-spacing bg-black text-center">
                    <p className="large color-white">Today, I have the confidence that I need to learn and grow in any situation. Because of Global Citizen Year, I’m more open to taking risks, embracing failures, and chasing uncertainty.”</p>
                    <img src="/images/impact/mouna-head.png" className="headshot" alt="author headshot"/>
                    <p className="credit mini color-white">Mouna Algahaithi, Senegal 2014, University of Wisconsin Madison 2019<br />Education Specialist, PBS</p>
                </div>
            </section>

             <section>
                <div className="block standard-spacing two-col-block">
                    <div>
                        <img src="/images/impact/chart.png" alt="transformative photo" />
                    </div>
                    <div>
                        <h3>Lead with Purpose</h3>
                        <p>Alumni are aligning their work with their convictions</p>
                        <div className="flex">
                            <span className="boldItal">84%</span>
                            <p>believe their Global Citizen Year made them more aware of their strengths and weaknesses as a leader</p>
                        </div>
                        <div className="flex">
                            <span className="boldItal">77%</span>
                            <p>believe their Global Citizen Year helped them develop a clearer sense of purpose</p>
                        </div>
                        <div className="flex">
                            <span className="boldItal">72%</span>
                            <p>believe their Global Citizen Year influenced the career path they chose to pursue</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="standard-spacing no-padding-top no-padding-bottom remove-padding-tablet">
                <div className="block quote-block standard-spacing bg-black text-center">
                    <p className="large color-white">In Ecuador I discovered an interest at the intersection of energy and sustainability, and this has informed everything I’ve done since. My Global Citizen Year gave me the space to discern what I’m passionate about, and the courage to pursue it.”</p>
                    <img src="/images/impact/jordan-head.png" className="headshot" alt="author headshot"/>
                    <p className="credit mini color-white">Jordan Lee, Ecuador 2013, Yale University 2017<br />Research Analyst, McKinsey & Company</p>
                </div>
            </section>

            <section>
                <div className="block standard-spacing block-life-impact" ref="a-lifetime-of-impact">
                    <p className="pre-header font-bold orange">A Lifetime of Impact</p>
                    <h2 className="h1">Alumni are leading lives that change the world</h2>
                    <p className="h3">Our alumni are thriving in colleges and careers in over 60 countries. They’re being honored with prestigious awards and recognition and are working for influential organizations and companies. Global Citizen Year alumni are already having an outsized impact on society; and they’re just getting started!</p>

                    <div className="logos">
                        <img src="/images/impact/impact_logos/fulbright.svg" alt="logo" />
                        <img src="/images/impact/impact_logos/tesla.svg" alt="logo" />
                        <img src="/images/impact/impact_logos/gates.svg" alt="logo" />
                        <img src="/images/impact/impact_logos/ashoka.png" alt="logo" style={{ width: '100px' }} />
                        <img src="/images/impact/impact_logos/tfa.svg" alt="logo" />
                        <img src="/images/impact/impact_logos/un.svg" alt="logo" />
                        <img src="/images/impact/impact_logos/amazon.svg" alt="logo" />
                    </div>
                </div>
                 <img className="strokes" src="/images/impact/yellow-strokes-alt.png" alt="strokes" />
            </section>

            <section className="bg-dark-grey">
                <div className="block standard-spacing block-download">
                    <div>
                     <img src="/images/impact/impact_logos/booklet.png" alt="booklet mockup" />
                    </div>
                    <div>
                        <h3 className="boldItal">Download our Alumni Outcomes Report</h3>
                        <p>Marking a decade of impact, our Alumni Outcomes Report shows how our programs are equipping students with a sense of purpose, a global perspective, and the agency to take ownership of their education.</p>
                        <a href="https://downloads.ctfassets.net/j91b9gwu8s3q/32J3zMCSMMQys86qYmwq0I/3b6474e8c8e1e301bd0121c0cc4e71a6/20-0702_GCY_Impact_Report.pdf" target="_blank" className="hoverlink">Download Now</a>
                    </div>
                </div>
            </section>
            {
                this.props.data && this.props.data.page.fellowCards &&
                <Fellows
                  title="Hear from Global Citizen Year Students"
                  cards={this.props.data.page.fellowCards}
                />
            }
            <section className="block-cta bg-dark-grey">
                <div className="content capper standard-spacing text-center">
                    <h1 className="h1 text-center color-white">The Future is up to you</h1>
                    <p className="text-center color-white">Join our <a href="/partners-and-supporters/" className="color-orange">amazing community of donors</a> to launch the leaders the world needs now.<br/>
                    Global Citizen Year is a 501c3, non-profit, and all contributions are fully tax-deductible.</p>
                    <Button
                        text="Donate"
                        href="/donate/"
                        hoverwhite
                    />
                </div>
            </section>
        </div>
    )
  }
}

export default Impact

export const query = graphql`
query impactQuery {
  page: contentfulAboutPage {
    fellowCards {
      fellowsLocation
      fellowsName
      fellowsQuote {
        id
        fellowsQuote
      }
      fellowsLink {
        text
        link
      }
      image {
        file {
          url
        }
        title
      }
    }
  }
}`



// WEBPACK FOOTER //
// ./src/pages/our-impact.js